import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { CommonService, LeadService } from '../../_services/';


@Component({
  selector: 'app-node',
  templateUrl: './node.component.html',
  styleUrls: ['./node.component.scss']
})
export class NodeComponent implements OnInit {
  nid:string;
  errMsg='';
  constructor(
    private _route: ActivatedRoute,
    private _common:CommonService,
    private _lead: LeadService,
    private router: Router
  ) { }

  ngOnInit() {
    this._route.paramMap.subscribe(params => {
      this.nid = params.get("id"); 
      this.validateNID(this.nid);
    })
  }



  validateNID(nid){
    this._common.showLoader(true);
    this.errMsg = "";
    this._lead.validateNID(nid).subscribe(res=>{
      this._common.showLoader(false);
      if(res && res.type==="VALID_CONTACT"){
        this.router.navigateByUrl('/contact',nid);
        this.router.navigate(['/contact', nid]);
      }
      else if(res.type==="VALID_PROJECT"){
        this.router.navigate(['/project', nid]);
      }
      else {
        console.log('else block!!');
        this.errMsg = "Record does not exist";
      }
      
    },error=>{
      this._common.showLoader(false);
      this.errMsg = "Record does not exist";
    })
  }


}
